import { render } from "./InspectionBoard.vue?vue&type=template&id=04a1b982"
import script from "./InspectionBoard.vue?vue&type=script&lang=js"
export * from "./InspectionBoard.vue?vue&type=script&lang=js"

import "./InspectionBoard.vue?vue&type=style&index=0&id=04a1b982&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__